<template>
    <TextureForm :texture="texture" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import TextureForm from './TextureForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    TextureForm
  },
  data() {
    return {
      texture:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
     this.texture=await APIRequest.detail('textures',this.$route.params.id)
     this.loaded=true
  }
}
</script>
